import DropdownSearch from 'components/DropdownSearch'
import { isNil } from 'lodash'
import {
  MapFeatureType,
  useFeatureInteractionContext,
} from 'pages/siteView/siteMap/contexts/FeatureInteractionContext'
import { useTilesetMapFeatureHelpers } from 'pages/siteView/siteMap/tilesetMap/features/useTilesetMapFeatureHelpers'
import React, { FC } from 'react'
import styled from 'styled-components'
import { GeckoUnit, SiteFeaturePrimitive } from 'types'

const Section = styled.div`
  font-size: 16px;
  font-weight: 500;
  text-align: left;
  display: flex;
  gap: 8px;
  align-items: center;
  color: ${({ theme }) => theme.forecast.defaultText};
`

const Label = styled.div`
  flex-shrink: 0;
`

const StyledFilteredSearchContainer = styled.div`
  width: 24rem;
`

const ClearButtonDiv = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: left;
  align-items: center;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.forecast.border};
  font-family: sans-serif;
  width: fit-content;
  padding: 4px 8px;
  opacity: 0.8;

  &:hover {
    opacity: 1;
    background-color: ${({ theme }) => theme.forecast.hoverButton};
  }
`

interface UnitIDInputProps {
  feature: SiteFeaturePrimitive
  allUnitsAtSite: ReadonlyArray<GeckoUnit>
}

export const UnitIDInput: FC<UnitIDInputProps> = (props) => {
  const { setSelectedFeature } = useFeatureInteractionContext()
  const { updateFeaturePrimitive } = useTilesetMapFeatureHelpers()

  const unitName = props.allUnitsAtSite.find(
    (unit) => unit.id === props.feature.unit_id
  )?.data.name
  const itemGetter = (item: GeckoUnit) => item.data.name ?? item.id
  const itemSearchTerms = (item: GeckoUnit) => [item.id, item.data.name]
  const setSelectedUnit = (item: GeckoUnit | undefined) => {
    const unitID = item?.id ?? null
    const updatedFeature: SiteFeaturePrimitive = {
      ...props.feature,
      unit_id: unitID,
    }
    updateFeaturePrimitive(updatedFeature)
    setSelectedFeature(
      !isNil(unitID)
        ? {
            type: MapFeatureType.Unit,
            unitID: unitID,
          }
        : {
            type: MapFeatureType.Unknown,
            featureID: props.feature.id,
          }
    )
  }

  return (
    <Section>
      <Label>Name:</Label>
      <DropdownSearch>
        <DropdownSearch.Trigger>
          {unitName ?? 'Select a Unit'}
        </DropdownSearch.Trigger>
        <DropdownSearch.Menu>
          <StyledFilteredSearchContainer>
            <DropdownSearch.FilteredSearch
              listToFilter={props.allUnitsAtSite.slice()}
              itemGetter={itemGetter}
              itemSearchTerms={itemSearchTerms}
              placeholder='Search by name or ID...'
              onSelect={setSelectedUnit}
            />
          </StyledFilteredSearchContainer>
        </DropdownSearch.Menu>
      </DropdownSearch>
      {unitName && (
        <ClearButtonDiv onClick={() => setSelectedUnit(undefined)}>
          Clear
        </ClearButtonDiv>
      )}
    </Section>
  )
}
